import * as Yup from 'yup';
import { round } from 'lodash';

import { ApiTransactionRoutes } from '~services/apiTransaction/types';
import { VALIDATIONS_ERROR } from '~constants/validationsError';

export const FIELDS_NAME = {
  DRIVER: 'driver',
  VEHICLE: 'vehicle',
  TOTAL_KM: 'totalKm',
  TOTAL_TIME: 'totalTime',
} as const;

export const getParseMetersToKm = (distanceInMeters: number): number =>
  round(distanceInMeters / 1000, 3);

export const getParseKmToMeters = (distanceInKm: number): number =>
  round(distanceInKm * 1000);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (routeInfo: ApiTransactionRoutes) => ({
  [FIELDS_NAME.DRIVER]: routeInfo.driverId ?? '',
  [FIELDS_NAME.VEHICLE]: routeInfo.vehicleId ?? '',
  [FIELDS_NAME.TOTAL_KM]: String(
    getParseMetersToKm(routeInfo.distanceReal ?? 0),
  ),
  [FIELDS_NAME.TOTAL_TIME]: routeInfo.durationReal ?? 0,
});

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.DRIVER]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.VEHICLE]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.TOTAL_KM]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.TOTAL_TIME]: Yup.number()
    .required(VALIDATIONS_ERROR.REQUIRED)
    .moreThan(0, VALIDATIONS_ERROR.REQUIRED),
});
